import {
  buildCmsAiRequestHeaders,
  cmsApiUrl,
  getAiRequestSpotId,
  readCmsApiErrorMessage
} from '../cms-ai-api';

export async function runTranslateTextImplementation(data: {
  text?: string;
  targetLanguage?: string;
}) {
  const text = typeof data.text === 'string' ? data.text.trim() : '';
  const targetLanguage =
    typeof data.targetLanguage === 'string' && data.targetLanguage.trim() !== ''
      ? data.targetLanguage.trim()
      : 'de';

  if (!text) {
    throw new Error('Translate text: missing text input');
  }

  const spotId = getAiRequestSpotId();
  if (!spotId) {
    throw new Error('Translate text: missing spotId context');
  }

  const response = await fetch(cmsApiUrl('/api/translate'), {
    method: 'POST',
    headers: buildCmsAiRequestHeaders(),
    body: JSON.stringify({ spotId, text, targetLanguage })
  });

  if (!response.ok) {
    const detail = await readCmsApiErrorMessage(response);
    throw new Error(`Translate text failed: ${response.status} (${detail})`);
  }

  const payload = (await response.json()) as { translatedText?: string };
  const translatedText =
    typeof payload.translatedText === 'string' ? payload.translatedText : text;

  return { text: translatedText };
}
